import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from "react-redux";
import Documents from '../../../Pages/RsvpRegistration/Documents/Documents';
import { toast } from 'react-toastify';

const AdminEditDocuments = ({ guest, event, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        setShow(false);
        onChange();
        toast.success('Documents saved')
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>Edit Documents</button>

            <Modal className="guestpreview-modal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Documents</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Documents
                        onChange={onChange}
                        isAdmin={true}
                        guest={guest}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditDocuments);
